export default {
  GET_DASHBOARD_BEGIN: "GET_DASHBOARD_BEGIN",
  GET_DASHBOARD_SUCCESS: "GET_DASHBOARD_SUCCESS",
  GET_DASHBOARD_FAILURE: "GET_DASHBOARD_FAILURE",
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/constants.js